// not supported on web
export const ActionSheetProvider = ({ children }) => children;
export const connectActionSheet = a => a;



// WEBPACK FOOTER //
// ./src/@ui/ActionSheet/index.web.js